import { useMemo } from 'react';
import { InsightKeys } from '@constants/entities/insights';
import useProjectData from '@hooks/useProjectData';
import { skipToken } from '@reduxjs/toolkit/query';

const useCiaData = (projectId?: string | typeof skipToken) => {
  const [{ subscription, questionnaire }, { isLoading: isProjectLoading }] =
    useProjectData(projectId);

  const isCiaActivated = useMemo(() => {
    if (!subscription) return false;

    const isCiaInInsightsList = subscription.insights.includes(InsightKeys.CIA);

    return isCiaInInsightsList;
  }, [subscription]);

  return {
    isCiaActivated,
    questionnaire,
    isLoading: isProjectLoading,
  };
};

export default useCiaData;
